import useTranslation from './hooks/useTranslation';

import { FIELD_SECTION_KEY, OTHER_FIELD_SECTION_KEY, UNASSIGNED_SECTION_KEY } from './constants';
import type {
    BoundarySectionItem,
    GetSectionKey,
    PanelSection,
    Props,
    UseBoundarySectionsReturn
} from './types';

const useBoundarySections = ({ siteId }: Props): UseBoundarySectionsReturn => {
    const { FIELD_BOUNDARIES, OTHER_FIELD_BOUNDARIES, UNASSIGNED_BOUNDARIES } = useTranslation();

    const getSectionKey: GetSectionKey = (item: BoundarySectionItem) => {
        if (!item.siteId) {
            return UNASSIGNED_SECTION_KEY;
        }

        return item.siteId === siteId ? FIELD_SECTION_KEY : OTHER_FIELD_SECTION_KEY;
    };

    const sections: PanelSection[] = [
        { key: FIELD_SECTION_KEY, labelText: FIELD_BOUNDARIES },
        { key: UNASSIGNED_SECTION_KEY, labelText: UNASSIGNED_BOUNDARIES },
        { key: OTHER_FIELD_SECTION_KEY, labelText: OTHER_FIELD_BOUNDARIES }
    ];

    return {
        getSectionKey,
        sections
    };
};

export default useBoundarySections;
